import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-top: 5px;
  padding-right: 29px;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  overflow: scroll;
`;
Wrapper.displayName = 'Wrapper ';

export default Wrapper;
